import { NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChipSize, WcgChipModule, WcgChipType } from '@wcg/frontend-framework';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

import { PinCardComponent, WcgTruncatePipe } from '@erm/cluster';

import { SubmissionListItem } from '../../types';

import {
  PINNED_SUBMISSION_ICON_MAPPER,
  PINNED_SUBMISSION_NOTIFICATION_CHIP_MAPPER,
  PINNED_SUBMISSION_NOTIFICATION_LABEL_MAPPER,
  SUBMISSSION_DETAILS_V2_PATH,
} from '../../constants';

@Component({
  selector: 'wcg-pinned-submission',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PinCardComponent,
    WcgChipModule,
    MatTooltipModule,
    WcgTruncatePipe,
    MatIconModule,
    TitleCasePipe,
    NgxSkeletonLoaderComponent,
    NgTemplateOutlet,
  ],
  styleUrls: ['./pinned-submission.component.css'],
  templateUrl: './pinned-submission.component.html',
})
export class PinnedSubmissionComponent {
  private readonly _router = inject(Router);

  readonly loadSkeletonLoader = input<boolean>(false);
  readonly loadingStateViaCarousel = input<boolean>(false);
  readonly loadingStateClasses = input<string>('');

  readonly pinnedSubmission = input<SubmissionListItem>();

  readonly submissionIconMapper = PINNED_SUBMISSION_ICON_MAPPER;
  readonly notificationChipMapper = PINNED_SUBMISSION_NOTIFICATION_CHIP_MAPPER;
  readonly notificationLabelMapper =
    PINNED_SUBMISSION_NOTIFICATION_LABEL_MAPPER;
  readonly chipSize = ChipSize;
  readonly chipType = WcgChipType;
  readonly skeletonWidths = ['75%', '55%', '65%', '45%'];

  protected readonly $siteCount = computed(
    () => Object.keys(this.pinnedSubmission()?.sites ?? {}).length,
  );

  /** Navigates to the submission detail page using its int_id. */
  navigateToDetail(item: SubmissionListItem): void {
    this._router.navigate([`/${SUBMISSSION_DETAILS_V2_PATH}/`, item.int_id]);
  }
}
